module.exports = __webpack_public_path__ + "img/Diagnosis - Pink.c33ff816.png";